<script lang="ts">
  import { Trash } from "lucide-svelte"
  import Layout from "$app/Layouts/Admin.svelte"
  import DataTable from "$app/components/DataTable.svelte"
  import { colorBoolean, formatDate, xhr, toast } from "$app/utils"

  let props = $props()
  let subscription: SubscriptionType = props.subscription

  const fields = [
    { key: "id", label: "ID", sorting: false },
    { key: "role", label: "Role", sorting: false },
    {
      key: "name",
      label: "Name",
      sorting: false
    },
    {
      key: "created_at",
      label: "Created On",
      format: (d) => formatDate(d.created_at),
      sorting: false
    }
  ]

  //
  let coachFormStatus = ""
</script>

<Layout {...props}>
  <span slot="title">View Subscription ID: {subscription.id}</span>

  <div class="flex justify-start">
    <a
      href="/admin/subscriptions"
      class="hover:text-blue-500 hover:underline text-gray-700 text-lg"
      >Back to Subscriptions Index</a
    >
  </div>

  <div class="mt-4 border border-gray-500 rounded-lg p-6 shadow bg-white">
    <div class="flex gap-2 py-4 items-center">
      <div class="px-4">
        <span class="text-base text-gray-700">Subscription Name:</span>
        <span class="text-lg font-bold" title="Name">{subscription.name}</span>
      </div>
      <div class="px-4">
        <span class="text-base text-gray-700">Type:</span>
        <span class="text-lg font-bold" title="Name">{subscription.type}</span>
      </div>
    </div>

    <div>
      <div class="grid grid-cols-3 gap-2 h-16">
        <div>
          <span class="label-color">BILLING INTERVAL</span>
          {subscription.billing_interval || ""}
        </div>
        <div>
          <span class="label-color">NOTES</span>
          {subscription.notes || ""}
        </div>

        <div>
          <span class="label-color">STRIPE SUB ID</span>
          {subscription.stripe_id || ""}
        </div>
      </div>

      <div class="grid grid-cols-3 gap-2 h-16">
        <div>
          <span class="label-color">FULL ACCESS TOTAL</span>
          {subscription.full_access_total || ""}
        </div>

        <div>
          <span class="label-color">TEAM MEMBER TOTAL</span>
          {subscription.team_member_total || ""}
        </div>

        <div class="col-span-2">
          <span class="label-color">RECOGNITION MEMBER TOTAL</span>
          <span>
            {subscription.recognition_member_total || ""}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!--
  <div class="mt-4 border border-gray-500 rounded-lg p-6 shadow bg-white">
    <div class="flex gap-2 items-center mb-4">
      <h2 class="text-xl font-bold">Plans</h2>
    </div>

    <DataTable {fields} data={coaches}>
      <svelte:fragment slot="actions" let:item>
        <div class="flex gap-4">
          <button on:click={() => removeCoach(item)}>
            <Trash />
          </button>
        </div>
      </svelte:fragment>
    </DataTable>
  </div>
  -->
</Layout>
